//
//

export default {
  name: "ValidateTagProductPage",
};



// WEBPACK FOOTER //
// ./src/pages/validate/TagProduct.vue